import { bucketsStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

bucketsStyles.item = {
    width: 12,
    css: css`
        > div[class^="sc"] {
            margin-right: 15px;
        }
        > div:last-child[class^="sc"] {
            margin-right: 0;
        }
    `,
    style: {
        paddingBottom: "20px",
        minWidth: "600px",
    },
};
